import ThemeProvider from './ThemeProvider'

export { Theme } from '../../hooks/useTheme'

export default ThemeProvider
